/* eslint-disable react-native/no-inline-styles */
import {useNavigation, useRoute} from '@react-navigation/native';
import {Button, Text} from '@ui-kitten/components';
import React, {useState} from 'react';
import {StyleSheet, View, Platform} from 'react-native';
import {getIosPrice, px, useIsLandscape} from '../../utils';
import {Page} from '../components';
import Direct from './Direct';
import FreeMonthPayment from './FreeMonthPayment';
import InAppPayment from './InAppPayment';
import Manual from './Manual';

const Payment = ({landscapeParams, onModalBackPressed, handleCloseModal}) => {
  const isLandscape = useIsLandscape();
  const navigation = useNavigation();
  const {params} = useRoute();
  const [isManualSelected, setIsManualSelected] = useState(false);
  const isIOS = Platform.OS === 'ios';

  const {
    iosProductId,
    packageId,
    kidId,
    selectedTimeTable,
    subjectNames,
    renewData,
    totalPrice,
    transactionId,
    monthNumber,
    isRenew,
    isResubmit,
  } = landscapeParams || params;

  const numberOfSubjects = selectedTimeTable?.length || 0;

  const isFreeMonth = totalPrice === 0;

  return (
    <>
      <Page
        header={{title: 'Payment', showBackAction: true, onModalBackPressed}}
        useModalView={isLandscape}>
        <View style={styles.body}>
          {Platform.OS === 'ios' ? (
            <View
              style={{
                paddingHorizontal: 24,
              }}>
              <Text style={{fontSize: 20, fontWeight: '600'}}>
                {'Purchase Summary'}
              </Text>
              <Text style={{fontSize: 16, fontWeight: '600', marginTop: 8}}>
                {'Month :'} {monthNumber}
              </Text>
            </View>
          ) : (
            <>
              <Text style={{fontSize: 16, fontWeight: '600', marginLeft: 24}}>
                {'Pay to: Star Tutor Sdn Bhd'}
              </Text>
              <Text style={{fontSize: 16, fontWeight: '600', marginLeft: 24}}>
                {'Maybank'}
              </Text>
              <Text style={{fontSize: 16, fontWeight: '600', marginLeft: 24}}>
                {'5621 0681 8131'}
              </Text>
              <Text style={{marginTop: 10, marginLeft: 24}}>
                {'Company Registration No:'}
              </Text>
              <Text style={{marginLeft: 24}}>{'202101011639 (1411938-A)'}</Text>
            </>
          )}
          <View style={styles.priceBox}>
            <Text style={{fontSize: 16, fontWeight: '700'}}>
              {'Total Amount:'}
            </Text>
            <Text style={{fontSize: 16, fontWeight: '700'}}>
              RM{getIosPrice(totalPrice)}
            </Text>
          </View>

          {isFreeMonth ? (
            <>
              <FreeMonthPayment
                numberOfSubjects={numberOfSubjects}
                navigation={navigation}
                kidId={kidId}
                isRenew={isRenew}
                packageId={packageId}
                selectedTimeTable={selectedTimeTable}
                subjectNames={subjectNames}
                renewData={renewData}
                transactionId={transactionId}
                monthNumber={monthNumber}
                handleClosePaymentModal={handleCloseModal}
              />
            </>
          ) : (
            <>
              {isIOS ? (
                <InAppPayment
                  iosProductId={iosProductId}
                  numberOfSubjects={numberOfSubjects}
                  navigation={navigation}
                  kidId={kidId}
                  isRenew={isRenew}
                  packageId={packageId}
                  selectedTimeTable={selectedTimeTable}
                  subjectNames={subjectNames}
                  renewData={renewData}
                  transactionId={transactionId}
                  monthNumber={monthNumber}
                  handleClosePaymentModal={handleCloseModal}
                />
              ) : (
                <>
                  {!isManualSelected && (
                    <>
                      {!isResubmit && (
                        <>
                          <Text
                            style={{
                              fontSize: 20,
                              fontWeight: '500',
                              marginTop: 20,
                              marginBottom: 20,
                              textAlign: 'center',
                            }}>
                            {'Choose Payment Method'}
                          </Text>

                          <Direct
                            navigation={navigation}
                            kidId={kidId}
                            isRenew={isRenew}
                            packageId={packageId}
                            selectedTimeTable={selectedTimeTable}
                            subjectNames={subjectNames}
                            renewData={renewData}
                            transactionId={transactionId}
                            monthNumber={monthNumber}
                            handleClosePaymentModal={handleCloseModal}
                          />
                        </>
                      )}

                      <Button
                        style={{marginHorizontal: px(57), marginTop: 60}}
                        onPress={() => setIsManualSelected(true)}>
                        {'Upload Payment Slip'}
                      </Button>
                      <Text
                        style={{
                          fontWeight: '500',
                          marginTop: 10,
                          fontSize: 14,
                          textAlign: 'center',
                          marginHorizontal: 32,
                        }}>
                        {
                          'Payment will be verified and approved by the admin within 8-48 hours.'
                        }
                      </Text>
                    </>
                  )}
                  {isManualSelected && (
                    <Manual
                      navigation={navigation}
                      kidId={kidId}
                      isRenew={isRenew}
                      packageId={packageId}
                      selectedTimeTable={selectedTimeTable}
                      subjectNames={subjectNames}
                      renewData={renewData}
                      transactionId={transactionId}
                      monthNumber={monthNumber}
                      handleClosePaymentModal={handleCloseModal}
                    />
                  )}
                </>
              )}
            </>
          )}
        </View>
      </Page>
    </>
  );
};

const styles = StyleSheet.create({
  body: {
    paddingVertical: px(26),
  },
  priceBox: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingVertical: px(20),
    paddingHorizontal: px(15),
    borderRadius: 10,
    marginTop: px(24),
    marginHorizontal: px(16),
    backgroundColor: '#FFBE0B',
  },
});

export default Payment;
